/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAccessGovernance extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAccessGovernance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAccessGovernance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAccessGovernance>): BackgroundJobPayloadForPeriodicAccessGovernance {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAccessGovernance(), model);
        BackgroundJobPayloadForPeriodicAccessGovernance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAccessGovernance>): BackgroundJobPayloadForPeriodicAccessGovernance {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAccessGovernance.newInstance(<BackgroundJobPayloadForPeriodicAccessGovernance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAccessGovernance) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAccessGovernance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAccessGovernance): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAccessGovernance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
